import ApiKeysPage from "../../../component/organization/ApiKeys"

 
function ApiKeys() {
  return (
    <div className="page-body"><ApiKeysPage/></div>
  )
}

export default ApiKeys